import React, { ReactElement, useState } from "react";
// mui
import {
  Toolbar,
  Typography,
  IconButton,
  Box,
  Drawer,
  AppBar,
  Stack,
} from "@mui/material";
// icons
import { CgMenuRight } from "react-icons/cg";
// components
import LinksDrawer from "./LinksDrawer";
import LogoutButton from "../buttons/LogoutButton";
import AppLogo from "./AppLogo";
import ThemeToggler from "../buttons/ThemeToggler";
import UserMenu from "../buttons/UserMenu";
// utils
import { APP_NAME } from "../../utils/app-info";

// const drawerWidth = 280;
const SideDrawer = () => {
  const [drawerWidth, setDrawerWidth] = useState(280);
  const [showLinkIconsOnly, setShowLinkIconsOnly] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    if (showLinkIconsOnly === true) {
      setShowLinkIconsOnly(false);
      setDrawerWidth(280);
    }
  };

  // Remove this const when copying and pasting into your project.
  return (
    <Box sx={{ display: "flex" }}>
      {/* TOP BAR  */}
      <AppBar
        position="fixed"
        sx={[
          (theme) => ({
            width: { md: `calc(100% - ${drawerWidth}px)` },
            ml: { md: `${drawerWidth}px` },
            transition: "width 200ms",
            backgroundImage: "none",
          }),
          (theme) =>
            theme.applyStyles("dark", {
              // "& .MuiPaper-root": {
              backgroundColor: "#101010",
              // },
            }),
          (theme) =>
            theme.applyStyles("light", {
              // "& .MuiPaper-root": {
              backgroundColor: theme.palette.primary.main,
              // },
            }),
        ]}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Stack>
            {/* toggle links icons or icons and text  */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              // onClick={handleDrawerToggle}
              sx={{
                mr: 2,
                display: { xs: "none", md: "block" },
              }}
              onClick={() => {
                setShowLinkIconsOnly(!showLinkIconsOnly);
                if (showLinkIconsOnly) {
                  setDrawerWidth(280);
                } else {
                  setDrawerWidth(64);
                }
              }}
            >
              <CgMenuRight />
            </IconButton>
            {/* toggle sidebar in mobile screens  */}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { xs: "block", md: "none" } }}
            >
              <CgMenuRight />
            </IconButton>
            {/* <Typography variant="h6" noWrap component="div">
            {APP_NAME}
          </Typography> */}
          </Stack>
          <Stack direction="row" alignItems="center">
            <ThemeToggler />
            <UserMenu />
          </Stack>
        </Toolbar>
      </AppBar>
      {/* side bar  */}
      <Box
        component="nav"
        sx={{
          width: { md: drawerWidth },
          flexShrink: { md: 0 },
        }}
        aria-label="mailbox folders"
      >
        {/* mobile drawer  */}
        <Drawer
          // container={<Container />}
          variant="temporary"
          SlideProps={{
            direction: "left",
          }}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
          sx={[
            (theme) => ({
              display: { xs: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                transition: "width 200ms",
                py: 2,
              },
            }),
            (theme) =>
              theme.applyStyles("dark", {
                "& .MuiDrawer-paper": {
                  backgroundColor: "#101010",
                },
              }),
            (theme) =>
              theme.applyStyles("light", {
                "& .MuiDrawer-paper": {
                  background: `${theme.palette.primary.main}`,
                },
              }),
          ]}
        >
          <AppLogo showLinkIconsOnly={showLinkIconsOnly} />
          <LinksDrawer showLinkIconsOnly={showLinkIconsOnly} />
        </Drawer>
        {/* desktop drawer  */}
        <Drawer
          variant="permanent"
          SlideProps={{
            direction: "left",
          }}
          sx={[
            (theme) => ({
              display: { xs: "none", md: "block" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: drawerWidth,
                transition: "width 200ms",
                py: 2,
              },
            }),
            (theme) =>
              theme.applyStyles("dark", {
                "& .MuiDrawer-paper": {
                  backgroundColor: "#101010",
                },
              }),
            (theme) =>
              theme.applyStyles("light", {
                "& .MuiDrawer-paper": {
                  background: `${theme.palette.primary.main}`,
                },
              }),
          ]}
          open
        >
          <AppLogo showLinkIconsOnly={showLinkIconsOnly} />
          <LinksDrawer showLinkIconsOnly={showLinkIconsOnly} />
        </Drawer>
      </Box>
    </Box>
  );
};

export default SideDrawer;
